const bjpCandidatesProfession: string[] = [
  `Number one candidate's profession`,
  `No. 2 candidate's profession`,
  `Number three candidate's profession`,
]

export default bjpCandidatesProfession
